import React, { useEffect, useState } from "react";
import { Formik, Form, FormikHelpers } from "formik";
import CreatableSelect from "react-select";
import * as Yup from "yup";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../Appstore/store";
import { IoMdArrowRoundBack } from "react-icons/io";
import { GetallAgentsAndMonitors } from "../Features/Getallagentsmonitors";
import { components } from "react-select";
import { GetallsmsGatewayNumber } from "../Features/smscampaign/smsgatewaynumbers";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { IoCloseSharp } from "react-icons/io5";
import { setIsLoading } from "../Features/loadingSlice";
import { GetSmsCampaignView } from "../Features/smscampaign/Smscampaignview";
import { UpdateSmsCampaigns } from "../Features/smscampaign/Smscampaign";
import { toast } from "sonner";

interface FormValues {
  name: string;
  sendinglimit: string;
  smscampnumber: {
    sms_gateway_id: number;
    sms_gateway_number_id: number;
  }[];
  smscampuser: OptionType[];
  send_report_emails: string
}

interface smsCampaignDatatype {
  name: string;
  agent_sending_limit: string;
  sms_campaign_numbers: {
    sms_gateway_id: number;
    sms_gateway_number_id: number;
  }[];
  sms_campaign_users: number | any;
  send_report_emails: string
}

interface OptionType {
  value: number;
  label: string;
  role: "Agent" | "Monitor";
  email: string;
  id: number;
}

interface SmsCampaignNumber {
  sms_gateway_id: number | any;
  id: number | any;
}

function Updatesmscampaign() {
  const [smsGateway, setSMSGateway] = useState<{
    id: number;
    name: string;
  } | null>();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [loadingg, setLoading] = useState<boolean>(false);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [limit, setLimit] = useState(10);
  const [userOptions, setUserOptions] = useState<OptionType[]>([])

  function debounce(func: (...args: any[]) => void, delay: number) {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  }

  const debouncedSearch = debounce((inputValue: string) => {
    setSearchTerm(inputValue);
    setPage(1);
  }, 700);


  const { id }: any = useParams();

  const { smscampaignviewsdata } = useSelector(
    (state: RootState) => state.smscampaignview
  );
  const record: smsCampaignDatatype | any = smscampaignviewsdata.find(
    (recodID) => recodID.id === Number(id)
  );

  useEffect(() => {
    dispatch(GetallsmsGatewayNumber({ search: "", page: 1, limit: 10 }));
  }, [dispatch]);


  useEffect(() => {
    setLoading(true)
    if (loadingg) return;
    dispatch(GetallAgentsAndMonitors({ search: searchTerm, page, limit }))
      .then((response: any) => {
        const newData: OptionType[] =
          response?.payload?.data?.map((item: any) => ({
            value: item.id,
            label: item.name,
            role: item.role === 1 ? "Agent" : "Monitor",
            email: item.email,
            id: item.id,
          })) || [];

        setUserOptions(newData);
        setLoading(true)
        setHasMore(newData.length === limit);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [searchTerm, limit]);

  useEffect(() => {
    if (id) {
      dispatch(setIsLoading(true));
      dispatch(GetSmsCampaignView(id))
        .unwrap()
        .catch((err) => {
          console.error("Error fetching agent monitor:", err);
        })
        .finally(() => {
          setTimeout(() => dispatch(setIsLoading(false)), 500);
        });
    }
  }, [id, dispatch]);

  const loadMore = () => {
    if (!loading && hasMore) {
      setLimit((pre) => pre + 10);
    }
  };

  const { loading } = useSelector((state: RootState) => state.smscampaign);
  const { agentmonitordata } = useSelector(
    (state: RootState) => state.agentmonitor
  );

  const { smsgatewaynumber } = useSelector(
    (state: RootState) => state.smsgatewaynumber
  );

  useEffect(() => {
    const options: OptionType[] = agentmonitordata.map((item: any) => ({
      value: item.id,
      label: item.name,
      role: item.role === 1 ? "Agent" : "Monitor",
      email: item.email,
      id: item.id,
    }));
    setUserOptions(options);
  }, []);

  const validationSchema = Yup.object({
    name: Yup.string().required("Gateway Name is required").trim(),
    sendinglimit: Yup.string()
      .matches(/^\d+$/, "Only numbers are allowed.")
      .test('not-zero', 'Sending limit cannot be 0', (value) => value !== '0')
      .min(1, "Min 1 Sending limit")
      .required("Agent Sending Limit is required"),
    smscampnumber: Yup.array()
      .min(1, "At least one SMS Campaign Number must be selected") // Minimum one item
      .required("Please select at least one Number"), // Required field
    smscampuser: Yup.array().min(1, "Please select at least one user"),
    send_report_emails: Yup.string()
      .test("emailList", "Invalid email format", (value) => {
        if (!value) return true;
        const emails = value.split(",").map((email) => email.trim());
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        return emails.every((email, i) => emailRegex.test(email));
      })
      .test("duplicateEmail", "Duplicate email", (value) => {
        if (!value) return true;
        const emails = value.split(",").map((email) => email.trim());
        return emails.every((email, i) => emails.indexOf(email) === i);
      })
      .required()
      .label("Emails"),
  });

  const navigatetobackpage = () => {
    navigate(-1);
  };
  const handleSearchChange = (inputValue: string) => {
    if (inputValue.trim() !== searchTerm) {
      debouncedSearch(inputValue);
    }
  };

  const MultiValue = (props: any) => {
    return (
      <components.MultiValue {...props}>
        <span>{props.data.label}</span>
      </components.MultiValue>
    );
  };

  const CustomMenuList = (props: any) => {
    const { children, hasMore, loading, loadMore, selectProps } = props;

    return (
      <components.MenuList {...props}>
        {/* Optional custom header or message */}
        {selectProps.customMessage && (
          <div className="text-center py-1 text-muted">
            {selectProps.customMessage}
          </div>
        )}

        {loadingg && agentmonitordata ? (
          <div className="text-center">
            <div className="loader"></div>
          </div>
        ) : (
          children
        )}

        {hasMore && (
          <div className={`text-center mt-3 mx-2 ${loading ? 'd-none' : "d-block"}`}>
            <button
              className="btn btn-secondary w-100 bg-primary "
              onClick={(e) => {
                e.stopPropagation(); // Prevent dropdown from closing
                loadMore(); // Call the loadMore function
              }}
              disabled={loading}
            >
              {loading ? "Loading..." : "Load More"}
            </button>
          </div>
        )}
      </components.MenuList>
    );
  };

  useEffect(() => {
    document.addEventListener("click", (e: any) => {
      const d = document.getElementById("numbers_dropdowns");
      if (d?.contains(e.target)) return;
      d?.classList.remove("show");
    });
    return () => document.removeEventListener("click", () => { });
  }, []);

  const initialValues: FormValues = {
    name: record?.name || "",
    sendinglimit: record?.agent_sending_limit || "",
    smscampnumber: record?.sms_gateways_numbers
      ? record.sms_gateways_numbers.map((number: SmsCampaignNumber) => ({
        sms_gateway_id: number.sms_gateway_id,
        sms_gateway_number_id: number.id,
      }))
      : [],
    smscampuser: record?.users
      ? record.users.map((user: any) => ({
        value: user.id,
        id: user.id,
        email: user.email,
        role: user.role,
        label: user.name,
      }))
      : [],
    send_report_emails: record?.send_report_emails || "",
  };
  if (!record) {
    return <div>Loading record or record not found...</div>;
  }

  return (
    <>
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content">
            <div className="container-fluid">
              <div className="card mt-4">
                <div className="card-header bg-white p-3 d-flex justify-content-md-between">
                  <h2 className="w-100 mb-md-0 fs-3">Update SMS Campaign</h2>
                  <Link to={""} className="text-decoration-none">
                    <button
                      onClick={navigatetobackpage}
                      className="btn btn-info text-white d-flex align-items-center fw-semibold"
                    >
                      <IoMdArrowRoundBack /> Back
                    </button>
                  </Link>
                </div>
                <div className="card-body">
                  <Formik
                    initialValues={initialValues}
                    enableReinitialize={true}
                    validationSchema={validationSchema}
                    onSubmit={async (
                      values: FormValues,
                      { setSubmitting }: FormikHelpers<FormValues>
                    ) => {
                      const { id }: any = record;
                      const smsCampaignData: smsCampaignDatatype = {
                        name: values.name,
                        agent_sending_limit: values.sendinglimit,
                        sms_campaign_numbers: values.smscampnumber.map(
                          (number) => ({
                            sms_gateway_id: number.sms_gateway_id,
                            sms_gateway_number_id: number.sms_gateway_number_id,
                          })
                        ),
                        sms_campaign_users: values.smscampuser.map((user) =>
                          Number(user.value)
                        ),
                        send_report_emails: values?.send_report_emails
                      };

                      try {
                        const response: any = await dispatch(
                          UpdateSmsCampaigns({
                            id: id ?? 0,
                            updatedData: smsCampaignData,
                          })
                        );
                        if (
                          response.payload &&
                          response.payload.status === "success"
                        ) {
                          toast.success(response.payload.message);
                          navigate("/admin/sms-campaigns");
                        } else {
                          toast.error(response.payload.message);
                        }
                      } finally {
                        setSubmitting(false);
                      }
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      setFieldValue,
                      isSubmitting,
                    }) => (
                      <Form>
                        <div className="row">
                          <div className="form-group mb-3 col-md-6">
                            <label htmlFor="name">
                              Name<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control shadow-none ${touched.name && errors.name ? "is-invalid" : ""
                                }`}
                              id="name"
                              name="name"
                              placeholder="Enter Name"
                              onFocus={() => console.log(values)}
                              value={values.name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {touched.name && errors.name && (
                              <div className="text-danger">{errors.name}</div>
                            )}
                          </div>
                        </div>

                        <div className="row">
                          <div className="form-group mb-3 col-md-6">
                            <label htmlFor="sendinglimit">
                              Agent Sending Limit <span className="pb-1 fw-semibold" style={{ fontSize: "14px" }}>(per minutes)</span> <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control shadow-none ${touched.sendinglimit && errors.sendinglimit
                                ? "is-invalid"
                                : ""
                                }`}
                              id="sendinglimit"
                              name="sendinglimit"
                              placeholder="Enter Sending Limit"
                              value={values.sendinglimit}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {touched.sendinglimit && errors.sendinglimit && (
                              <div className="text-danger">{errors.sendinglimit}</div>
                            )}
                          </div>
                        </div>

                        {/* <div className="row">
                          <div className="form-group mb-3 col-md-6">
                            <label htmlFor="smscampuser">
                              SMS Campaign Users
                              <span className="text-danger">*</span>
                            </label>
                            <CreatableSelect
                              name="smscampuser"
                              isMulti
                              options={userOptions}
                              isLoading={loading}
                              placeholder="Search and select users"
                              classNamePrefix="select"
                              className={`shadow-none ${touched.smscampuser && errors.smscampuser
                                ? "is-invalid border-danger"
                                : ""
                                }`}
                              value={values.smscampuser}
                              onChange={(selectedOption) =>
                                setFieldValue("smscampuser", selectedOption)
                              }
                              formatOptionLabel={(option: OptionType) => (
                                <div className="d-flex justify-content-between align-items-center border-bottom py-1">
                                  <div>
                                    <p className="fw-semibold mb-0">
                                      {option.label}
                                    </p>{" "}
                                    <p style={{ fontSize: "14px", margin: 0 }}>
                                      {option.email}
                                    </p>{" "}
                                  </div>
                                  <span
                                    style={{
                                      width: "70px",
                                      fontSize: "14px",
                                      backgroundColor: "#e9ecf0",
                                    }}
                                    className="text-center rounded fw-semibold p-1"
                                  >
                                    {option.role}
                                  </span>{" "}
                                </div>
                              )}
                              components={{ MultiValue }}
                            />
                            {touched.smscampuser && errors.smscampuser && (
                              <div className="text-danger">
                                {errors.smscampuser as string}
                              </div>
                            )}
                          </div>
                        </div> */}

                        <div className="row">
                          <div className="form-group mb-3 col-md-6">
                            <label htmlFor="smscampuser">
                              SMS Campaign Users
                              <span className="text-danger">*</span>
                            </label>
                            <CreatableSelect
                              name="smscampuser"
                              isMulti
                              isSearchable={true}
                              options={userOptions}
                              filterOption={(o) => true}
                              isLoading={loading}
                              placeholder="Search and select users"
                              classNamePrefix="select"
                              className={`shadow-none ${touched.smscampuser && errors.smscampuser
                                ? "is-invalid border-danger"
                                : ""
                                }`}
                              value={values.smscampuser}
                              onChange={(selectedOption) => setFieldValue("smscampuser", selectedOption)}
                              onInputChange={(inputValue) => handleSearchChange(inputValue)}

                              formatOptionLabel={(option: OptionType) => (
                                <div className="d-flex justify-content-between align-items-center border-bottom py-1">
                                  <div>
                                    <p className="fw-semibold mb-0">
                                      {option.label}
                                    </p>{" "}
                                    {/* Name */}
                                    <p
                                      style={{ fontSize: "14px", margin: 0 }}
                                    >
                                      {option.email}
                                    </p>{" "}
                                    {/* Email */}
                                  </div>
                                  <span
                                    style={{
                                      width: "70px",
                                      fontSize: "14px",
                                      backgroundColor: "#e9ecf0",
                                    }}
                                    className="text-center rounded fw-semibold p-1"
                                  >
                                    {option.role}
                                  </span>{" "}
                                  {/* Role */}

                                </div>

                              )}

                              components={{
                                MenuList: (props) => (
                                  <CustomMenuList
                                    {...props}
                                    hasMore={hasMore} // Custom prop
                                    loading={loadingg} // Custom prop
                                    loadMore={loadMore} // Custom prop
                                  />
                                ),
                                MultiValue
                              }}
                            />
                            {
                              touched.smscampuser && errors.smscampuser && (
                                <div className="text-danger">
                                  {errors.smscampuser as string}
                                </div>
                              )
                            }
                          </div>
                        </div>

                        <div className="row">
                          <div className="form-group mb-3 col-md-6 d-flex flex-column">
                            <label>
                              SMS Campaign Numbers
                              <span className="text-danger">*</span>
                            </label>
                            <div className="dropdown">
                              <button
                                type="button"
                                style={{ height: "fit-content" }}
                                className={`custom dropdown-toggle w-100 text-start form-control shadow-none text-dark ${touched.smscampnumber && errors.smscampnumber
                                  ? "border-danger"
                                  : "btn border-input btn-focus-ring-primary"
                                  }`}
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const d =
                                    document.getElementById(
                                      "numbers_dropdowns"
                                    );
                                  if (d?.classList.contains("show"))
                                    d.classList.remove("show");
                                  else d?.classList.add("show");
                                }}
                              >
                                {values.smscampnumber.length > 0 ? (
                                  <div className="d-flex  gap-2 flex-wrap">
                                    {values.smscampnumber.map((item, i) => (
                                      <div
                                        className="d-flex gap-2 rounded-1 px-2 py-1 align-items-center"
                                        style={{
                                          height: "26.39px",
                                          backgroundColor: "#e6e6e8",
                                          maxWidth: "fit-content",
                                          fontSize: 14,
                                        }}
                                      >
                                        <span>
                                          {
                                            smsgatewaynumber
                                              ?.find(
                                                (g) =>
                                                  g.id === item?.sms_gateway_id
                                              )
                                              ?.sms_gateways_numbers.find(
                                                (n) =>
                                                  n.id ===
                                                  item.sms_gateway_number_id
                                              )?.gateway_number
                                          }
                                        </span>
                                        <IoCloseSharp
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setFieldValue(
                                              "smscampnumber",
                                              values.smscampnumber.filter(
                                                (n) =>
                                                  n.sms_gateway_number_id !==
                                                  item.sms_gateway_number_id
                                              )
                                            );
                                          }}
                                        />
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  "Select Numbers"
                                )}
                              </button>

                              <div
                                id="numbers_dropdowns"
                                className="dropdown-menu w-100 px-2"
                                aria-labelledby="dropdownMenuButton"
                                onClick={(e) => e.stopPropagation()}
                              >
                                {smsGateway ? (
                                  <>
                                    <div className="px-3 p-2 border-bottom d-flex justify-content-between  align-items-center">
                                      <p className="mb-0">{smsGateway?.name}</p>
                                      <p
                                        className="mb-0 d-flex justify-content-center align-items-center"
                                        onClick={() => setSMSGateway(null)}
                                      >
                                        <FaChevronLeft
                                          className="me-1"
                                          style={{ fontSize: "14px" }}
                                        />
                                        Back
                                      </p>
                                    </div>
                                    {smsgatewaynumber
                                      .find((item) => item.id === smsGateway.id)
                                      ?.sms_gateways_numbers?.map((item, i) => (
                                        <div
                                          className="px-3 p-2 border-bottom d-flex gap-2 user-select-none"
                                          key={i}
                                        >
                                          {item.gateway_number && (
                                            <>
                                              <input
                                                type="checkbox"
                                                checked={
                                                  values.smscampnumber.find(
                                                    (c) =>
                                                      c.sms_gateway_number_id ===
                                                      item.id
                                                  )
                                                    ? true
                                                    : false
                                                }
                                                onChange={() => {
                                                  if (
                                                    values.smscampnumber.find(
                                                      (c) =>
                                                        c.sms_gateway_number_id ===
                                                        item.id
                                                    )
                                                  )
                                                    setFieldValue(
                                                      "smscampnumber",
                                                      values.smscampnumber.filter(
                                                        (n) =>
                                                          n.sms_gateway_number_id !==
                                                          item.id
                                                      )
                                                    );
                                                  else
                                                    setFieldValue(
                                                      "smscampnumber",
                                                      [
                                                        ...values.smscampnumber,
                                                        {
                                                          sms_gateway_id:
                                                            smsGateway.id,
                                                          sms_gateway_number_id:
                                                            item.id,
                                                        },
                                                      ]
                                                    );
                                                }}
                                                id={`sms_camp_number_${item.id}`}
                                              />
                                              <label
                                                className="mb-0 fw-semibold"
                                                htmlFor={`sms_camp_number_${item.id}`}
                                              >
                                                {item.gateway_number}
                                              </label>
                                            </>
                                          )}
                                        </div>
                                      ))}
                                  </>
                                ) : (
                                  smsgatewaynumber?.map((item, i) => (
                                    <div
                                      onClick={() =>
                                        setSMSGateway({
                                          id: item.id!,
                                          name: item?.name!,
                                        })
                                      }
                                      className="px-3 p-2 border-bottom d-flex justify-content-between align-items-center"
                                      key={i}
                                    >
                                      <p className="mb-0">{item?.name}</p>
                                      <FaChevronRight />
                                    </div>
                                  ))
                                )}
                              </div>
                            </div>
                            {touched.smscampnumber && errors.smscampnumber && (
                              <div className="text-danger">
                                {Array.isArray(errors.smscampnumber)
                                  ? errors.smscampnumber.map((error, i) => (
                                    <div key={i}>{error as string}</div>
                                  ))
                                  : errors.smscampnumber}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="row">
                          <div className="form-group mb-3 col-md-6">
                            <label htmlFor="send_report_emails">
                              Emails <small>{"("}This email receives daily SMS reports for this campaign.{")"}</small><span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control shadow-none ${touched.send_report_emails && errors.send_report_emails
                                ? "is-invalid"
                                : ""
                                }`}
                              id="send_report_emails"
                              name="send_report_emails"
                              placeholder="Enter Name"
                              value={values.send_report_emails}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {touched.send_report_emails && errors.send_report_emails && (
                              <div className="text-danger">{errors.send_report_emails}</div>
                            )}
                          </div>
                        </div>

                        <div className="d-flex">
                          <button
                            type="submit"
                            className="btn btn-primary me-2"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span className="ps-2">Save...</span>
                              </>
                            ) : (
                              "Save"
                            )}
                          </button>
                          <Link
                            to="/admin/sms-campaigns"
                            className="btn btn-secondary"
                          >
                            Cancel
                          </Link>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default Updatesmscampaign;
